import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const AUTH_STATE = 'auth';

const authState = createFeatureSelector<AuthState>(AUTH_STATE);

export const getAuthStateSelect = createSelector(authState, (state) => {
    return state;
})